import { addCollection } from 'iconify-icon';
import type { IconifyJSON } from '@iconify/types';
import tablerRaw from '@iconify-json/tabler/icons.json';

const tabler = tablerRaw as unknown as IconifyJSON;

// Ikonice koje se koriste u applikaciji (Kako se ne bi budlovale sve ikoncie)
const TABLER_ICONS = [
  'layout-dashboard',
  'users',
  'handshake',
  'id',
  'user-shield',
  'menu-2',
  'moon',
  'sun',
  'language',
  'user-circle',
  'login',
  'logout',
  'chevron-left',
  'chevron-right',
  'chevrons-left',
  'chevrons-right',
  'circle-chevron-down',
  'search',
  'x',
  'filter',
  'edit',
  'trash',
  'eye',
];

export function registerAppIcons(): void {
  // Tabler ikonice registracija
  addCollection({
    prefix: 'tabler',
    icons: Object.fromEntries(
      TABLER_ICONS.map(name => [name, tabler.icons[name]]).filter(
        ([, icon]) => icon != null,
      ),
    ),
    width: 24,
    height: 24,
  });

  // Custom ikonice
  addCollection({
    prefix: 'app',
    icons: {
      // Primer custom ikone
      'waste-hazard': {
        body: '<path stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" fill="none" d="M12 9v4m0 4h.01M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"/>',
      },
    },
    width: 24,
    height: 24,
  });
}
